import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../../../components/Common/Actions";
import FilledButton from "../../../../components/Common/Buttons/FilledButton";
import CommonFilterModal from "../../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../../components/Common/TabBar";
import ListPageLayout from "../../../../components/Layout";
import Deletepopup from "../../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../../components/Utils/hooks/useSortHandler";
import {
  PartneredPharmaciesBreadcrumbs,
  PartneredPharmaciesnavBarData,
  statuses,
} from "../../Utils/MasterConst";

const Inventory = () => {
  const navigate = useNavigate();
  const addNewInventoryValue = {
    id: "addnewpost",
    onClick: () => navigate("/master-inventory-create"),
    style: { width: "240px" },
    label: "Add New Inventory Value",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    "Inventory Value": [],
    Status: [],
  });
  const [tempSelectedValues, setTempSelectedValues] = useState({
    "Inventory Value": [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("Inventory Value");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [loader, setLoader] = useState(true);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}inventory-value/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "inventory-value",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search, selectedValues]);

  useEffect(() => {
    (async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}inventory-value/getarray`,
      );
      if (response.data) {
        setFilters({ ...filters, "Inventory Value": response.data });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Inventory Value",
      width: 280,
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Status",
      dataIndex: "active",
      width: 150,
      key: "active",
      render: (active) => (active ? "Verified" : "Not Verified"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Actions
            isEdit={true}
            isDelete={true}
            isView={true}
            onClickView={() => navigate(`/master-inventory-view/${record._id}`)}
            onClickDelete={() => {
              setDeleteId(record._id);
              setShowDelete(true);
            }}
            onClickEdit={() => navigate(`/master-inventory-edit/${record._id}`)}
          />
        </div>
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  const InventoryValues = [
    "Less than 3 Lakhs",
    "5 - 20 Lakhs",
    "20 - 50 Lakhs",
    "50 Lakhs - 1 Crore",
    "More than 1 Crore",
  ];

  const [filters, setFilters] = useState({
    "Inventory Value": InventoryValues,
    Status: statuses,
  });

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<PartneredPharmaciesBreadcrumbs last="Inventory Value" />}
      addButton={<FilledButton props={addNewInventoryValue} />}
      titles={<NavBarTitles titles={PartneredPharmaciesnavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={async () => {
          await setSelectedValues(tempSelectedValues);
          await setIsFilterModalVisible(false);
          await setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          // await fetchData();
        }}
        onReset={() => {
          setTempSelectedValues({ "Inventory Value": [], Status: [] });
          setSelectedValues({ "Inventory Value": [], Status: [] });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default Inventory;
